export default "__VITE_ASSET___TqEQ7IC__"